import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, HttpApiQueryRepository, interpolate } from '@softline/core';
import { SOFTLINE_API_CLAIM_REPORT_DOCUMENT_QUERY } from '../claim-report.api';
import { ClaimReportCustomerQueryRow } from '../types/claim-report-document-query';

@Injectable()
export class ClaimReportCustomerRepository extends HttpApiQueryRepository<ClaimReportCustomerQueryRow> {
  constructor() {
    super(
      inject(ApiDataAccess),
      interpolate(SOFTLINE_API_CLAIM_REPORT_DOCUMENT_QUERY, { documentType: 'SALES_ORDER' })
    );
  }
}
